const eventNav = document.querySelector('.event__wrapper__nav')
const eventContent = document.querySelector('.event__wrapper__content')

if (eventNav) {
    if (eventNav.scrollHeight >= eventContent.scrollHeight) {
        eventNav.style.maxHeight = 'unset'
    }
}